import { render, staticRenderFns } from "./SelectDict.vue?vue&type=template&id=a163a9e0&"
import script from "./SelectDict.vue?vue&type=script&lang=js&"
export * from "./SelectDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports